module.exports = __webpack_public_path__ + "static/media/duplicar.1beb8938.png";